import { useEffect } from 'react';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InteractiveEducationButton = ({
  additionalTracking,
  action,
  display,
  handleClick,
  title,
  use,
  size
}) => {
  useEffect(() => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, additionalTracking, {
      action
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(AIButton, {
    onClick: handleClick,
    size: size,
    usageTracker: UsageTracker.tracker,
    use: use,
    children: [title, display ? /*#__PURE__*/_jsx(UpIcon, {
      alignWithText: true
    }) : /*#__PURE__*/_jsx(DownIcon, {
      alignWithText: true
    })]
  });
};
export default InteractiveEducationButton;